var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4301 9.334C14.9841 8.84533 15.3334 8.13 15.3334 7.33333L15.3334 4.66667C15.3334 3.194 14.1394 2 12.6667 2L6.66675 2C5.19408 2 4.00008 3.194 4.00008 4.66667L4.00008 7.33333C4.00008 8.806 5.19408 10 6.66675 10H9.33341M1.57008 6.666C1.01608 7.15467 0.666748 7.87 0.666748 8.66667L0.666748 11.3333C0.666748 12.806 1.86075 14 3.33341 14L9.33341 14C10.8061 14 12.0001 12.806 12.0001 11.3333V8.66667C12.0001 7.194 10.8061 6 9.33341 6L6.66675 6",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.2493b113.svg";
export { ForwardRef as ReactComponent };